import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Clock } from 'lucide-react';
import { Button } from './Button';
import { track, PRODUCT } from '../lib/fpixel';
const INCLUDES = ['Descarga inmediata.', 'Acceso de por vida.', 'Actualizaciones.', 'Compatible con celular y computadora.'];
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : initialSeconds);
    }, 1000);
    return () => clearInterval(id);
  }, [initialSeconds]);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}
export function Offer() {
  const time = useCountdown(5 * 3600 + 59 * 60 + 59);
  return <section className="py-24 md:py-32 px-6 bg-white" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <motion.div id="oferta" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} onViewportEnter={() => track('ViewContent', {
        content_name: PRODUCT.content_name,
        content_category: PRODUCT.content_category,
        value: PRODUCT.value,
        currency: PRODUCT.currency
      })} className="scroll-mt-24 bg-white rounded-[3rem] shadow-[0_20px_60px_rgba(0,0,0,0.08)] border border-gray-100 p-8 md:p-16 text-center relative overflow-hidden" data-id="element-111">
          {/* Decorative background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-64 bg-green-50 rounded-full blur-3xl -z-10" data-id="element-112" />

          {/* Urgency */}
          <div className="inline-flex items-center gap-2 text-sm text-gray-500 mb-8 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-113">
            <Clock className="w-4 h-4 text-accent" data-id="element-114" />
            La oferta termina en
            <span className="font-mono font-bold text-gray-900 bg-gray-50 px-2 py-1 rounded" data-id="element-115">
              {time}
            </span>
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-gray-500 uppercase tracking-widest mb-4" data-id="element-116">
            VALOR TOTAL
          </h3>
          <p className="text-4xl md:text-5xl font-serif font-bold text-gray-400 line-through decoration-red-400 decoration-4 mb-12" data-id="element-117">
            $59.960
          </p>

          <div className="bg-primary text-white rounded-[2.5rem] py-12 px-6 mb-8 shadow-2xl shadow-primary/30 relative" data-id="element-118">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white text-sm font-black uppercase tracking-widest px-6 py-2 rounded-full shadow-lg" data-id="element-119">
              Oferta Especial
            </div>
            <p className="font-bold text-sm md:text-base uppercase tracking-widest text-green-100 mb-4" data-id="element-120">
              HOY ACCEDÉS A TODO POR
            </p>
            <p className="font-serif font-black leading-none flex justify-center items-start mb-6" data-id="element-121">
              <span className="text-4xl md:text-5xl mt-2 mr-1" data-id="element-122">$</span>
              <span className="text-7xl md:text-9xl tracking-tighter" data-id="element-123">
                19.990
              </span>
            </p>
            <p className="text-lg md:text-xl font-medium text-green-50" data-id="element-124">
              Menos de lo que cuesta salir a comer una sola vez.
            </p>
          </div>

          {/* Green Box Includes */}
          <div className="bg-green-50/50 rounded-3xl p-8 mb-10 border border-green-100" data-id="element-125">
            <div className="grid sm:grid-cols-2 gap-y-4 gap-x-6 text-left" data-id="element-126">
              {INCLUDES.map((inc, i) => <div key={i} className="flex items-center gap-3" data-id="element-127">
                  <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-128">
                    <Check className="w-5 h-5 text-white" data-id="element-129" />
                  </div>
                  <span className="text-base md:text-lg font-medium text-gray-800" data-id="element-130">
                    {inc}
                  </span>
                </div>)}
            </div>
          </div>

          <Button className="w-full" data-id="element-131">
            QUIERO VOLVER A DISFRUTAR LA COMIDA
          </Button>

          <p className="text-sm text-gray-400 mt-6 flex items-center justify-center gap-2" data-id="element-132">
            🔒 Pago 100% seguro y encriptado
          </p>
        </motion.div>
      </div>
    </section>;
}